<template>
  <div>
    <el-row>
      <div class="title">Request Services Help</div>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-link class="requestTrainingLink" icon="el-icon-video-camera" :underline="false" @click="handleClick">Tutorial Videos</el-link>
      </el-col>
    </el-row>
    <el-dialog title="Request Services Help" :visible.sync="trainingModal" width="80%" :before-close="handleClose" :destroy-on-close="true">
      <el-row :gutter="20">
        <el-col v-for="video in videos" :key="video.embedId" :span="12">
          <div class="videoTitle">{{ video.title }}</div>
          <iframe
            width="100%"
            height="360"
            :src="`https://www.youtube.com/embed/${video.embedId}`"
            :title="video.title"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'requestTraining',
  data: function() {
    return {
      trainingModal: false,
      videos: [
        { title: 'Request Monthly Acute Coding Services', embedId: '3lAVoRdJ2Xw' },
        { title: 'Request Monthly ProFee Coding Services', embedId: 'GuwW8_tMRWs' }
      ]
    }
  },
  methods: {
    handleClick() {
      this.trainingModal = true
    },
    handleClose() {
      this.trainingModal = false
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
>>> .requestTrainingLink .el-link--inner {
  font-size: 12px;
}

>>> .title {
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 0.1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: 400;
  unicode-bidi: isolate;
}

.videoTitle {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}
</style>
